import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row, Button } from "reactstrap";
import ContactUs from "../../components/common/ContactUs";

/**
 * QikTruck Partner Driver Agreement (South Africa) - 2026
 * Fully aligned with Public Terms and Conditions for marketplace liability protection
 */
class Section extends Component {
  // Generate PDF from the agreement content
  downloadPDF = () => {
    const agreementContent = document.getElementById("agreement-content");
    const printWindow = window.open("", "_blank");
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>QikTruck Partner Driver Agreement 2026</title>
          <style>
            @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              line-height: 1.6;
              color: #333;
              max-width: 800px;
              margin: 0 auto;
              padding: 40px;
              font-size: 11pt;
            }
            h1 {
              text-align: center;
              color: #1a73e8;
              font-size: 24pt;
              margin-bottom: 10px;
              border-bottom: 3px solid #1a73e8;
              padding-bottom: 10px;
            }
            h2 {
              color: #1a73e8;
              font-size: 14pt;
              margin-top: 24px;
              margin-bottom: 12px;
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
            }
            h3 {
              color: #333;
              font-size: 12pt;
              margin-top: 18px;
              margin-bottom: 8px;
            }
            h4 {
              color: #555;
              font-size: 11pt;
              margin-top: 14px;
              margin-bottom: 6px;
            }
            p {
              margin-bottom: 10px;
              text-align: justify;
            }
            ul, ol {
              margin-bottom: 10px;
              padding-left: 25px;
            }
            li {
              margin-bottom: 5px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin: 15px 0;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
              font-size: 10pt;
            }
            th {
              background-color: #f5f5f5;
              font-weight: bold;
            }
            .header-info {
              text-align: center;
              margin-bottom: 20px;
              color: #666;
            }
            .recitals {
              background-color: #f9f9f9;
              padding: 15px;
              border-left: 4px solid #1a73e8;
              margin: 15px 0;
            }
            .important-box {
              background-color: #fff3cd;
              border: 1px solid #ffc107;
              padding: 10px;
              margin: 10px 0;
              border-radius: 4px;
            }
            .signature-section {
              margin-top: 40px;
              page-break-inside: avoid;
            }
            .signature-line {
              border-bottom: 1px solid #333;
              width: 250px;
              display: inline-block;
              margin: 5px 0;
            }
            .page-break {
              page-break-before: always;
            }
            @page {
              margin: 2cm;
            }
          </style>
        </head>
        <body>
          ${agreementContent.innerHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    
    // Wait for content to load, then trigger print
    printWindow.onload = function() {
      printWindow.print();
    };
  };

  render() {
    const lastUpdated = "1 January 2026";
    const version = "2026.1";

    return (
      <React.Fragment>
        <SEO
          title="QikTruck Partner Driver Agreement - Independent Driver Contract for Transport Services in South Africa"
          titleTemplate="QikTruck"
          titleSeparator="-"
          description="QikTruck Partner Driver Agreement for independent transport providers. Read the full contract terms for drivers offering truck, bakkie, and delivery services through the QikTruck platform in South Africa."
          image="https://media.qiktruck.co.za/qiktruck-preview-header.png"
          pathname="https://qiktruck.co.za/partner-driver-agreement"
          twitterUsername="qiktrucksa"
        />

        <section id="home" style={{ paddingTop: "100px" }}>
          <Container>
            <Row className="justify-content-center">
              <Col lg={10}>
                {/* Download Button */}
                <div className="mb-4 text-center">
                  <Button
                    color="primary"
                    size="lg"
                    onClick={this.downloadPDF}
                    className="mb-3"
                  >
                    <i className="mdi mdi-download mr-2"></i>
                    Download Agreement as PDF
                  </Button>
                  <p className="text-muted">
                    Click the button above to download or print this agreement
                  </p>
                </div>

                <div className="mb-4" id="agreement-content">
                  <div className="page">
                    <div className="translations-content-container">
                      <div className="container">
                        <div className="tab-content translations-content-item en visible" id="en">
                          
                          {/* TITLE */}
                          <h1 style={{ textAlign: "center", color: "#1a73e8" }}>
                            QIKTRUCK PARTNER DRIVER AGREEMENT
                          </h1>
                          <p style={{ textAlign: "center", color: "#666" }}>
                            <strong>Effective Date:</strong> {lastUpdated}<br />
                            <strong>Version:</strong> {version}
                          </p>

                          <hr />

                          {/* PARTIES */}
                          <h2>PARTIES</h2>
                          <p>
                            <strong>QikTruck (Pty) Ltd</strong> (Registration No: [________])<br />
                            ("QikTruck" or the "Platform Operator")
                          </p>
                          <p><strong>AND</strong></p>
                          <p>
                            The individual or entity accepting this Agreement by electronic acceptance or signature<br />
                            ("Driver" or "You")
                          </p>

                          <hr />

                          {/* RECITALS */}
                          <h2>RECITALS</h2>
                          <div style={{ backgroundColor: "#f9f9f9", padding: "15px", borderLeft: "4px solid #1a73e8", margin: "15px 0" }}>
                            <p><strong>WHEREAS:</strong></p>
                            <p>
                              A. QikTruck operates an online technology platform ("Platform") that <strong>facilitates Booking requests</strong> between Customers seeking transport, delivery, courier, or removal services ("Transport Services") and independent transport providers who offer such services.
                            </p>
                            <p>
                              B. QikTruck acts solely as a <strong>technology intermediary and collection agent</strong> for Drivers and <strong>does not contract for transport</strong>, <strong>does not assume custody of goods</strong>, and <strong>does not guarantee completion of any Booking</strong>.
                            </p>
                            <p>
                              C. The Driver wishes to make transport services available to Customers through the Platform as a <strong>principal</strong> in respect of carriage performance, and not as an employee, agent, or representative of QikTruck.
                            </p>
                            <p>
                              D. The <strong>contract of carriage</strong> for each Booking is formed directly between the <strong>Customer and the Driver</strong>. QikTruck is not a party to any contract of carriage.
                            </p>
                            <p>
                              E. QikTruck does not provide Transport Services. QikTruck's role is limited to operating the Platform, facilitating payment collection on the Driver's behalf, and providing certain administrative and support services.
                            </p>
                          </div>

                          <hr />

                          {/* SECTION 1: INTERPRETATION AND DEFINITIONS */}
                          <h2>1. INTERPRETATION AND DEFINITIONS</h2>
                          
                          <h3>1.1 Definitions</h3>
                          <p>In this Agreement, unless the context indicates otherwise:</p>
                          
                          <table style={{ width: "100%", borderCollapse: "collapse", margin: "15px 0" }}>
                            <thead>
                              <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <th style={{ border: "1px solid #ddd", padding: "10px", width: "30%" }}>Term</th>
                                <th style={{ border: "1px solid #ddd", padding: "10px" }}>Definition</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Booking</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>A confirmed request for Transport Services placed by a Customer via the Platform and accepted by the Driver.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>CPA</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The Consumer Protection Act 68 of 2008.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Customer</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>A person or entity that requests, books, or receives Transport Services through the Platform.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Driver Earnings</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The Transport Service Fee less the Platform Fee and any applicable deductions, offsets, or withholdings.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Driver Account</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The Driver's registered account on the Platform.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Fees</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>All amounts payable for or in connection with Transport Services, including the Transport Service Fee and Platform Fee.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Platform</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The QikTruck website, mobile applications, and related technology services.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Platform Fee</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The service fee charged by QikTruck for facilitating Bookings and collecting payments, as displayed on the Platform.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>POPIA</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The Protection of Personal Information Act 4 of 2013.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Prohibited Goods</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>Goods prohibited from transport under this Agreement and the Platform Terms, including illegal items, hazardous materials, and items listed in Schedule A.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Transport Service</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>Transport, delivery, collection, courier, removal, or related logistics services performed by the Driver for a Customer.</td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}><strong>Transport Service Fee</strong></td>
                                <td style={{ border: "1px solid #ddd", padding: "10px" }}>The amount payable by a Customer for Transport Services as quoted or agreed via the Platform.</td>
                              </tr>
                            </tbody>
                          </table>

                          <h3>1.2 Interpretation</h3>
                          <p>1.2.1 Headings are for reference only and do not affect interpretation.</p>
                          <p>1.2.2 References to statutes include amendments and successor legislation.</p>
                          <p>1.2.3 Words importing one gender include other genders; singular includes plural and vice versa.</p>
                          <p>1.2.4 "Include" and "including" are not words of limitation.</p>

                          <hr />

                          {/* SECTION 2: MARKETPLACE ROLE AND RELATIONSHIP */}
                          <h2>2. MARKETPLACE ROLE AND RELATIONSHIP</h2>

                          <h3>2.1 Platform Facilitation</h3>
                          <p>
                            2.1.1 QikTruck operates a technology marketplace that <strong>facilitates Booking requests</strong> between Customers and Drivers. QikTruck <strong>does not provide Transport Services</strong> and <strong>is not a carrier</strong>.
                          </p>
                          <p>2.1.2 The Driver acknowledges and agrees that:</p>
                          <ul>
                            <li>(a) QikTruck's role is limited to operating the Platform and providing administrative facilitation;</li>
                            <li>(b) QikTruck <strong>does not contract for transport</strong> on behalf of Customers or Drivers;</li>
                            <li>(c) QikTruck <strong>does not guarantee completion</strong> of any Booking;</li>
                            <li>(d) QikTruck acts as <strong>collection agent</strong> for the Driver in receiving payments from Customers.</li>
                          </ul>

                          <h3>2.2 Contract of Carriage – Customer and Driver</h3>
                          <div style={{ backgroundColor: "#fff3cd", border: "1px solid #ffc107", padding: "15px", margin: "10px 0", borderRadius: "4px" }}>
                            <p>
                              2.2.1 <strong>A confirmed Booking creates a contract for the Transport Service directly between the Customer and the Driver.</strong> QikTruck is not a party to this contract of carriage.
                            </p>
                            <p>
                              2.2.2 <strong>The Driver is the principal</strong> in respect of carriage performance. The Driver contracts directly with the Customer for the Transport Service.
                            </p>
                          </div>
                          <p>2.2.3 The Driver <strong>bears all responsibility</strong> for:</p>
                          <ul>
                            <li>(a) Performance of the Transport Service;</li>
                            <li>(b) Safety of persons and goods during transport;</li>
                            <li>(c) Compliance with statutory obligations and applicable laws;</li>
                            <li>(d) All liabilities arising from the Driver's performance or non-performance.</li>
                          </ul>

                          <h3>2.3 No Custody, No Bailee, No Goods Risk</h3>
                          <div style={{ backgroundColor: "#fff3cd", border: "1px solid #ffc107", padding: "15px", margin: "10px 0", borderRadius: "4px" }}>
                            <p>
                              2.3.1 <strong>QikTruck never takes possession, custody, or control of any cargo</strong> transported under a Booking. QikTruck <strong>is not a bailee</strong> in respect of any goods.
                            </p>
                          </div>
                          <p>2.3.2 At all times, custody and control of goods remain with the Customer and the Driver, as between themselves.</p>
                          <p>2.3.3 QikTruck <strong>does not assume any risk</strong> in relation to loss of, or damage to, goods transported under any Booking.</p>
                          <p>2.3.4 Risk of loss or damage to goods remains with the Customer and the Driver as between themselves, and not with QikTruck.</p>

                          <h3>2.4 Independent Contractor Status</h3>
                          <p>2.4.1 The Driver is an <strong>independent contractor</strong> and not an employee, agent, partner, joint venturer, or representative of QikTruck.</p>
                          <p>2.4.2 Nothing in this Agreement creates an employment relationship, agency, partnership, or joint venture.</p>
                          <p>2.4.3 The Driver has <strong>no authority</strong> to:</p>
                          <ul>
                            <li>(a) Enter into contracts on QikTruck's behalf;</li>
                            <li>(b) Represent or hold out as having authority to bind QikTruck;</li>
                            <li>(c) Make commitments or representations to Customers on QikTruck's behalf;</li>
                            <li>(d) Create any financial or legal obligation binding on QikTruck.</li>
                          </ul>
                          <p>2.4.4 The Driver must not represent to any third party that the Driver is an employee, agent, or representative of QikTruck, or that QikTruck is responsible for the Transport Service.</p>

                          <hr />

                          {/* SECTION 3: NO EXCLUSIVITY AND MULTI-PLATFORM FREEDOM */}
                          <h2>3. NO EXCLUSIVITY AND MULTI-PLATFORM FREEDOM</h2>

                          <h3>3.1 Non-Exclusive Arrangement</h3>
                          <p>3.1.1 This Agreement is <strong>non-exclusive</strong>. The Driver is free to provide transport services through other platforms, directly to customers, or through any other lawful means.</p>
                          <p>3.1.2 The Driver may operate on <strong>competing platforms</strong> simultaneously.</p>

                          <h3>3.2 Freedom to Set Availability</h3>
                          <p>3.2.1 The Driver has complete freedom to:</p>
                          <ul>
                            <li>(a) Determine the days and times the Driver is available on the Platform;</li>
                            <li>(b) Accept or decline any Booking request;</li>
                            <li>(c) Go online or offline on the Platform at any time;</li>
                            <li>(d) Determine the geographic areas in which the Driver operates.</li>
                          </ul>
                          <p>3.2.2 QikTruck does not require:</p>
                          <ul>
                            <li>(a) Minimum hours or uptime on the Platform;</li>
                            <li>(b) Minimum number of Bookings to be accepted;</li>
                            <li>(c) Shift schedules or compulsory availability periods.</li>
                          </ul>

                          <h3>3.3 Right to Decline</h3>
                          <p>3.3.1 The Driver may decline any Booking request for any lawful reason without penalty, subject to not engaging in unlawful discrimination.</p>
                          <p>3.3.2 However, patterns of excessive cancellations after acceptance may be considered under the Platform's quality and reliability standards.</p>

                          <hr />

                          {/* SECTION 4: DRIVER RESPONSIBILITIES AND OBLIGATIONS */}
                          <h2>4. DRIVER RESPONSIBILITIES AND OBLIGATIONS</h2>

                          <h3>4.1 Driver is Principal for Transport Service</h3>
                          <p>4.1.1 <strong>The Driver is solely responsible</strong> for performing the Transport Service to Customers.</p>
                          <p>4.1.2 The Driver bears all performance, safety, and statutory obligations relating to the Transport Service.</p>
                          <p>4.1.3 The Driver warrants that they have the legal capacity, skills, equipment, and insurance necessary to perform Transport Services.</p>

                          <h3>4.2 Route and Method Selection</h3>
                          <p>4.2.1 <strong>The Driver and the Customer determine the execution of the Transport Service</strong>, including route selection, loading, securing, and unloading of goods.</p>
                          <p>4.2.2 QikTruck does not direct or control how the Driver performs Transport Services.</p>
                          <p>4.2.3 The Driver is responsible for selecting the route and method of performing the Transport Service, subject to lawful and safe operation.</p>

                          <h3>4.3 Legal and Regulatory Compliance</h3>
                          <p>The Driver must:</p>
                          <ul>
                            <li>(a) Maintain a valid driver's licence appropriate to the vehicle class;</li>
                            <li>(b) Hold a valid Professional Driving Permit (PrDP) where required by law;</li>
                            <li>(c) Ensure the vehicle is legally registered, licensed, and roadworthy;</li>
                            <li>(d) Comply with all applicable traffic laws, by-laws, and regulations;</li>
                            <li>(e) Obtain and maintain all permits required for the Transport Services;</li>
                            <li>(f) Comply with all tax obligations and register for VAT if required;</li>
                            <li>(g) Not transport Prohibited Goods.</li>
                          </ul>

                          <h3>4.4 Vehicle Condition and Equipment</h3>
                          <p>The Driver must:</p>
                          <ul>
                            <li>(a) Keep the vehicle in safe operating condition;</li>
                            <li>(b) Perform regular preventative maintenance;</li>
                            <li>(c) Use appropriate load-securing equipment (straps, ropes, blankets, etc.);</li>
                            <li>(d) Maintain the vehicle in clean, professional condition;</li>
                            <li>(e) Ensure the vehicle is suitable for the type of Bookings accepted.</li>
                          </ul>

                          <h3>4.5 Service Performance Standards</h3>
                          <p>The Driver must:</p>
                          <ul>
                            <li>(a) Perform Transport Services with reasonable care, skill, and diligence;</li>
                            <li>(b) Arrive within agreed time windows where reasonably possible;</li>
                            <li>(c) Notify Customers and/or QikTruck promptly if delayed;</li>
                            <li>(d) Follow Booking details including addresses, instructions, and special handling;</li>
                            <li>(e) Treat Customers and recipients respectfully and professionally;</li>
                            <li>(f) Handle goods with reasonable care appropriate to item type;</li>
                            <li>(g) Verify collection and delivery using Platform features (OTP, signature, photos);</li>
                            <li>(h) Provide proof of delivery where required.</li>
                          </ul>

                          <h3>4.6 Subcontracting and Helpers</h3>
                          <p>4.6.1 The Driver may not transfer a Booking to another driver or vehicle without prior approval through the Platform.</p>
                          <p>4.6.2 If the Driver uses helpers, the Driver remains fully responsible for their conduct and compliance.</p>

                          <hr />

                          {/* SECTION 5: CPA ALIGNMENT AND CLAIMS RESPONSIBILITY */}
                          <h2>5. CPA ALIGNMENT AND CLAIMS RESPONSIBILITY</h2>

                          <h3>5.1 Driver Responsibility for CPA Performance Claims</h3>
                          <p>5.1.1 <strong>The Driver is responsible</strong> for addressing any claims by Customers relating to:</p>
                          <ul>
                            <li>(a) Quality of the Transport Service (CPA section 54);</li>
                            <li>(b) Performance of the Transport Service;</li>
                            <li>(c) Delay, non-delivery, or partial delivery;</li>
                            <li>(d) Damage to or loss of goods;</li>
                            <li>(e) Any other service-related complaints.</li>
                          </ul>
                          <p>5.1.2 QikTruck may <strong>pass through</strong> Customer complaints, disputes, and chargebacks to the Driver.</p>
                          <p>5.1.3 The Driver must <strong>cooperate</strong> with QikTruck in handling any Customer complaint or claim, including providing information, documentation, and responses within reasonable timeframes.</p>

                          <h3>5.2 Claims Flow</h3>
                          <p>5.2.1 Any claim for <strong>non-performance, delay, damage, or loss</strong> relating to the Transport Service is a claim against <strong>the Driver</strong>, not QikTruck.</p>
                          <p>5.2.2 QikTruck <strong>is not jointly or severally liable</strong> with the Driver for the performance of the Transport Service.</p>
                          <p>5.2.3 QikTruck may facilitate communication, refunds, or dispute handling between Customers and Drivers, but this does not make QikTruck liable for the Driver's acts or omissions.</p>

                          <h3>5.3 Direct Customer Claims</h3>
                          <p>5.3.1 Customers may pursue claims directly against the Driver under contract law or the CPA for losses arising from the Driver's non-performance.</p>
                          <p>5.3.2 The Driver acknowledges that Customers retain all rights under the CPA to pursue remedies against the Driver.</p>

                          <hr />

                          {/* SECTION 6: REFUNDS, CHARGEBACKS, AND REIMBURSEMENTS */}
                          <h2>6. REFUNDS, CHARGEBACKS, AND REIMBURSEMENTS</h2>

                          <h3>6.1 Refund Reimbursement</h3>
                          <p>6.1.1 If QikTruck refunds a Customer for any reason related to the Driver's performance, non-performance, or conduct, <strong>QikTruck is entitled to recover the full amount</strong> of such refund from the Driver.</p>
                          <p>6.1.2 This includes refunds for:</p>
                          <ul>
                            <li>(a) Non-delivery or failed Bookings attributable to the Driver;</li>
                            <li>(b) Damage to goods attributable to the Driver;</li>
                            <li>(c) Delay causing the Customer to cancel;</li>
                            <li>(d) Customer dissatisfaction with Driver conduct or service quality;</li>
                            <li>(e) Any other legitimate Customer complaint relating to the Transport Service.</li>
                          </ul>

                          <h3>6.2 Chargebacks</h3>
                          <p>6.2.1 If QikTruck receives a chargeback from a payment provider or bank relating to a Booking performed by the Driver, and the chargeback is not due to QikTruck's fault, QikTruck may recover the chargeback amount from the Driver.</p>
                          <p>6.2.2 QikTruck will provide reasonable notice and details of chargebacks where practicable.</p>

                          <h3>6.3 Right of Offset and Setoff</h3>
                          <p>6.3.1 QikTruck may <strong>set off or deduct</strong> from amounts otherwise payable to the Driver any:</p>
                          <ul>
                            <li>(a) Refunds issued to Customers;</li>
                            <li>(b) Chargebacks received;</li>
                            <li>(c) Fines, penalties, or regulatory charges arising from the Driver's conduct;</li>
                            <li>(d) Amounts owed by the Driver under this Agreement;</li>
                            <li>(e) Insurance excesses or claim payments;</li>
                            <li>(f) Compensation paid by QikTruck to third parties due to Driver conduct;</li>
                            <li>(g) Amounts relating to fraud or suspected fraud.</li>
                          </ul>

                          <h3>6.4 Suspension of Withdrawals</h3>
                          <p>6.4.1 QikTruck may <strong>suspend or hold</strong> Driver Earnings withdrawals for Bookings that are:</p>
                          <ul>
                            <li>(a) Subject to Customer dispute or investigation;</li>
                            <li>(b) Under fraud review;</li>
                            <li>(c) Subject to chargeback requests;</li>
                            <li>(d) Associated with a pending claim or complaint.</li>
                          </ul>
                          <p>6.4.2 QikTruck will release held amounts within a reasonable time once the dispute or investigation is resolved, less any amounts properly deducted.</p>

                          <hr />

                          {/* SECTION 7: INSURANCE OBLIGATIONS */}
                          <h2>7. INSURANCE OBLIGATIONS</h2>

                          <h3>7.1 Mandatory Insurance</h3>
                          <p>7.1.1 The Driver must maintain at all times:</p>
                          <ul>
                            <li>(a) <strong>Comprehensive motor vehicle insurance</strong> covering the vehicle used for Transport Services;</li>
                            <li>(b) <strong>Third-party liability insurance</strong> adequate to cover liability to third parties for death, injury, or property damage;</li>
                            <li>(c) Any other insurance required by law.</li>
                          </ul>

                          <h3>7.2 Goods-in-Transit Insurance</h3>
                          <p>7.2.1 The Driver is strongly encouraged to maintain <strong>goods-in-transit (GIT) insurance</strong> covering loss of or damage to goods during transport.</p>
                          <p>7.2.2 Where GIT insurance is a requirement for certain Booking types (as indicated on the Platform), the Driver may only accept such Bookings if adequate GIT insurance is in place.</p>
                          <p>7.2.3 The Driver is responsible for understanding and complying with the terms, conditions, and exclusions of any GIT policy.</p>

                          <h3>7.3 Disclosure Obligations</h3>
                          <p>7.3.1 The Driver must <strong>immediately disclose</strong> to QikTruck any:</p>
                          <ul>
                            <li>(a) Collision, accident, or incident involving the Driver's vehicle while performing a Booking;</li>
                            <li>(b) Suspension or cancellation of the Driver's driving licence or PrDP;</li>
                            <li>(c) Determination that the vehicle is unroadworthy;</li>
                            <li>(d) Cancellation, suspension, or material change to any required insurance policy;</li>
                            <li>(e) Any event that could affect insurability, safety, or the Driver's ability to perform services.</li>
                          </ul>

                          <h3>7.4 Failure to Maintain Insurance</h3>
                          <div style={{ backgroundColor: "#f8d7da", border: "1px solid #f5c6cb", padding: "15px", margin: "10px 0", borderRadius: "4px" }}>
                            <p>7.4.1 <strong>Failure to maintain required insurance</strong> constitutes a material breach of this Agreement and grounds for:</p>
                            <ul>
                              <li>(a) Immediate suspension from the Platform;</li>
                              <li>(b) Termination of this Agreement;</li>
                              <li>(c) Withholding of Driver Earnings pending investigation;</li>
                              <li>(d) Recovery from the Driver of any losses, claims, or liabilities that would have been covered by insurance.</li>
                            </ul>
                          </div>

                          <h3>7.5 Evidence of Insurance</h3>
                          <p>7.5.1 QikTruck may request evidence of insurance at any time, and the Driver must provide copies of policies or certificates within 5 business days of request.</p>
                          <p>7.5.2 Failure to provide evidence when requested may result in suspension.</p>

                          <hr />

                          {/* SECTION 8: CLAIMS COOPERATION */}
                          <h2>8. CLAIMS COOPERATION</h2>

                          <h3>8.1 Obligation to Cooperate</h3>
                          <p>8.1.1 The Driver must cooperate fully and promptly with QikTruck, Customers, and insurers in relation to any incident, claim, complaint, or investigation.</p>

                          <h3>8.2 Information to be Provided</h3>
                          <p>8.2.1 The Driver must provide, on request and without delay:</p>
                          <ul>
                            <li>(a) <strong>Photos</strong> of the vehicle, goods, damage, or incident scene;</li>
                            <li>(b) <strong>Incident details</strong> including description, cause, and circumstances;</li>
                            <li>(c) <strong>Police case numbers</strong> where a police report was or should have been made;</li>
                            <li>(d) <strong>Timeline</strong> of events before, during, and after the incident;</li>
                            <li>(e) <strong>Witness details</strong> including names and contact information;</li>
                            <li>(f) <strong>Beneficiary details</strong> where claims involve third parties;</li>
                            <li>(g) <strong>Insurance claim reference numbers</strong>;</li>
                            <li>(h) Any other documentation reasonably required.</li>
                          </ul>

                          <h3>8.3 Mitigation</h3>
                          <p>8.3.1 The Driver must take reasonable steps to mitigate losses after an incident, including securing goods, contacting emergency services where necessary, and notifying relevant parties promptly.</p>

                          <hr />

                          {/* SECTION 9: INDEMNITIES */}
                          <h2>9. INDEMNITIES</h2>

                          <h3>9.1 General Indemnity</h3>
                          <p>9.1.1 The Driver <strong>indemnifies and holds harmless</strong> QikTruck, its directors, employees, agents, and affiliates from and against all claims, liabilities, damages, losses, costs, and expenses (including legal costs) arising from or in connection with:</p>
                          <ul>
                            <li>(a) The Driver's performance or non-performance of Transport Services;</li>
                            <li>(b) Any breach of this Agreement by the Driver;</li>
                            <li>(c) Any negligent, reckless, or unlawful act or omission by the Driver;</li>
                            <li>(d) Any claim by a Customer or third party relating to the Transport Service.</li>
                          </ul>

                          <h3>9.2 CPA Performance Claims Indemnity</h3>
                          <p>9.2.1 The Driver indemnifies QikTruck against any <strong>CPA performance claims</strong> made by Customers, including claims for:</p>
                          <ul>
                            <li>(a) Defective or inadequate performance of the Transport Service;</li>
                            <li>(b) Quality, fitness for purpose, or safety defects;</li>
                            <li>(c) Non-delivery, delay, or partial performance;</li>
                            <li>(d) Any remedy sought under CPA section 54 or related provisions.</li>
                          </ul>

                          <h3>9.3 Delay Indemnity</h3>
                          <p>9.3.1 The Driver indemnifies QikTruck against any claims or losses arising from <strong>delay</strong> in performing the Transport Service, including Customer claims for consequential losses.</p>

                          <h3>9.4 Load Damage Indemnity</h3>
                          <p>9.4.1 The Driver indemnifies QikTruck against any claims for <strong>damage to or loss of goods</strong> during loading, transport, unloading, or at any time the goods are in the Driver's care, custody, or control.</p>

                          <h3>9.5 Misdeclared Goods Indemnity</h3>
                          <p>9.5.1 The Driver indemnifies QikTruck against any claims arising from the Driver's transport of goods that were <strong>misdeclared, mislabelled, or misrepresented</strong> by the Customer, where the Driver:</p>
                          <ul>
                            <li>(a) Failed to reasonably verify the goods matched the Booking description; or</li>
                            <li>(b) Knew or should have known the goods were misdeclared but proceeded regardless.</li>
                          </ul>

                          <h3>9.6 Unlawful Goods Indemnity</h3>
                          <p>9.6.1 The Driver indemnifies QikTruck against any claims, penalties, fines, or losses arising from the Driver's transport of <strong>unlawful, prohibited, or illegal goods</strong>, including where the Driver:</p>
                          <ul>
                            <li>(a) Knew or should have known the goods were unlawful;</li>
                            <li>(b) Failed to exercise reasonable diligence in verifying the goods;</li>
                            <li>(c) Transported goods listed as Prohibited Goods.</li>
                          </ul>

                          <h3>9.7 Subrogation and Third-Party Claims</h3>
                          <p>9.7.1 If QikTruck or any insurer suffers a loss due to the Driver's conduct and the insurer exercises <strong>subrogation rights</strong> against QikTruck, the Driver indemnifies QikTruck for any such subrogated claim.</p>
                          <p>9.7.2 The Driver must cooperate with insurers and their representatives in connection with any subrogation claim.</p>

                          <hr />

                          {/* SECTION 10: PAYMENT AND COLLECTION AGENT */}
                          <h2>10. PAYMENT AND COLLECTION AGENT</h2>

                          <h3>10.1 QikTruck as Collection Agent</h3>
                          <p>10.1.1 The Driver hereby <strong>appoints QikTruck as collection agent</strong> for the purpose of:</p>
                          <ul>
                            <li>(a) Receiving payment from Customers for Transport Services on the Driver's behalf;</li>
                            <li>(b) Issuing tax invoices or receipts to Customers on the Driver's behalf;</li>
                            <li>(c) Collecting, holding, and disbursing Transport Service Fees.</li>
                          </ul>
                          <p>10.1.2 QikTruck acts as <strong>collection agent and not as principal supplier</strong> of the Transport Service.</p>
                          <p>10.1.3 Payment received by QikTruck from a Customer constitutes payment to the Driver, and the Customer's payment obligation to the Driver is discharged upon payment to QikTruck.</p>

                          <h3>10.2 Tax Invoices and Receipts</h3>
                          <p>10.2.1 QikTruck is authorised to issue tax invoices and receipts <strong>on the Driver's behalf</strong> for Transport Services.</p>
                          <p>10.2.2 Such invoices are issued in QikTruck's capacity as collection agent and not as supplier of the Transport Service.</p>
                          <p>10.2.3 The Driver remains responsible for compliance with tax and invoicing requirements under applicable law.</p>

                          <h3>10.3 Platform Fee</h3>
                          <p>10.3.1 QikTruck will deduct the <strong>Platform Fee</strong> from amounts collected before disbursement to the Driver.</p>
                          <p>10.3.2 The Platform Fee percentage or amount will be displayed on the Platform and may be updated from time to time with reasonable notice.</p>

                          <h3>10.4 Disbursement</h3>
                          <p>10.4.1 Driver Earnings will be disbursed in accordance with the payment schedule and methods displayed on the Platform.</p>
                          <p>10.4.2 Disbursement is subject to:</p>
                          <ul>
                            <li>(a) Verification of the Driver's bank account details;</li>
                            <li>(b) Completion of required KYC/FICA documentation;</li>
                            <li>(c) No pending disputes, claims, chargebacks, or investigations;</li>
                            <li>(d) No suspension or hold under this Agreement.</li>
                          </ul>

                          <h3>10.5 VAT Mechanics</h3>
                          <p>10.5.1 If the Driver is or becomes registered for <strong>VAT</strong>, the Driver must notify QikTruck immediately and provide a valid VAT registration number.</p>
                          <p>10.5.2 QikTruck will adjust invoicing and tax documentation to reflect VAT-compliant treatment upon notification.</p>
                          <p>10.5.3 The Driver is responsible for accounting for and paying any VAT due on the Driver's supplies.</p>

                          <h3>10.6 Withholding and Offset</h3>
                          <p>10.6.1 QikTruck may <strong>withhold, set off, or deduct</strong> from Driver Earnings any amounts relating to:</p>
                          <ul>
                            <li>(a) Chargebacks and refunds (per Section 6);</li>
                            <li>(b) Amounts owed under indemnities (per Section 9);</li>
                            <li>(c) Fines, penalties, or regulatory charges relating to Driver conduct;</li>
                            <li>(d) Insurance claims, excesses, or recoveries;</li>
                            <li>(e) Disputed Bookings pending resolution;</li>
                            <li>(f) Fraud or suspected fraud;</li>
                            <li>(g) Any other amounts owed by the Driver under this Agreement.</li>
                          </ul>

                          <hr />

                          {/* SECTION 11: SUSPENSION */}
                          <h2>11. SUSPENSION</h2>

                          <h3>11.1 Grounds for Suspension</h3>
                          <p>11.1.1 QikTruck may <strong>suspend</strong> the Driver's access to the Platform, without terminating this Agreement, for any of the following reasons:</p>
                          <ul>
                            <li>(a) <strong>Safety concerns</strong> including unsafe driving, vehicle defects, or incidents;</li>
                            <li>(b) <strong>Complaints</strong> from Customers regarding conduct, service quality, or safety;</li>
                            <li>(c) <strong>Insurance lapse</strong> or failure to maintain required insurance;</li>
                            <li>(d) <strong>Vehicle issues</strong> including unroadworthiness, failed inspections, or non-compliance;</li>
                            <li>(e) <strong>Fraud signals</strong> including suspicious activity, false information, or manipulation;</li>
                            <li>(f) <strong>Licence issues</strong> including suspension, cancellation, or expiry of driving licence or PrDP;</li>
                            <li>(g) <strong>Pending investigation</strong> into conduct or complaints;</li>
                            <li>(h) <strong>Regulatory requirements</strong> or legal process;</li>
                            <li>(i) <strong>Failure to cooperate</strong> with claims, investigations, or information requests;</li>
                            <li>(j) Any other material concern relating to safety, compliance, or service quality.</li>
                          </ul>

                          <h3>11.2 Effect of Suspension</h3>
                          <p>11.2.1 During suspension:</p>
                          <ul>
                            <li>(a) The Driver may not access the Platform or accept Bookings;</li>
                            <li>(b) Driver Earnings may be held pending investigation or resolution;</li>
                            <li>(c) The Driver must cooperate with any investigation or remediation.</li>
                          </ul>

                          <h3>11.3 Reinstatement</h3>
                          <p>11.3.1 QikTruck may, in its discretion, reinstate the Driver upon resolution of the suspension grounds and completion of any required remediation.</p>
                          <p>11.3.2 QikTruck is not obligated to reinstate any suspended Driver.</p>

                          <hr />

                          {/* SECTION 12: BRANDING AND INTELLECTUAL PROPERTY */}
                          <h2>12. BRANDING AND INTELLECTUAL PROPERTY</h2>

                          <h3>12.1 Limited Licence</h3>
                          <p>12.1.1 Subject to compliance with this Agreement, QikTruck grants the Driver a limited, non-exclusive, revocable licence to use QikTruck branding materials (if provided) solely for the purpose of identifying the Driver's participation on the Platform.</p>

                          <h3>12.2 No Proprietary Rights</h3>
                          <p>12.2.1 <strong>No proprietary rights</strong> in QikTruck's intellectual property, trademarks, or branding are granted or transferred to the Driver under this Agreement.</p>
                          <p>12.2.2 The Driver acquires no ownership rights in QikTruck's name, logo, or branding.</p>

                          <h3>12.3 Branding Restrictions</h3>
                          <p>12.3.1 The Driver must not:</p>
                          <ul>
                            <li>(a) Use QikTruck branding in any manner that implies <strong>agency, employment, or partnership</strong> with QikTruck;</li>
                            <li>(b) Use QikTruck branding in misleading advertising or communications;</li>
                            <li>(c) Modify, alter, or create derivative works of QikTruck branding;</li>
                            <li>(d) Use QikTruck branding after termination or suspension.</li>
                          </ul>

                          <h3>12.4 Removal of Branding</h3>
                          <p>12.4.1 QikTruck may <strong>require immediate removal</strong> of all QikTruck branding from the Driver's vehicle or materials at any time, including upon suspension or termination.</p>
                          <p>12.4.2 Upon termination or suspension, the Driver must remove all QikTruck branding within 24 hours.</p>

                          <hr />

                          {/* SECTION 13: DISPUTE RESOLUTION */}
                          <h2>13. DISPUTE RESOLUTION</h2>

                          <h3>13.1 Informal Resolution</h3>
                          <p>13.1.1 The parties agree to first attempt to resolve any dispute informally through good faith discussions.</p>

                          <h3>13.2 Mediation</h3>
                          <p>13.2.1 If a dispute is not resolved informally within 14 days, either party may refer the dispute to mediation.</p>
                          <p>13.2.2 Mediation does not prevent either party from proceeding to arbitration if mediation is unsuccessful.</p>

                          <h3>13.3 AFSA Arbitration</h3>
                          <p>13.3.1 Subject to Section 13.5, any dispute arising from or in connection with this Agreement that is not resolved informally or through mediation will be <strong>finally resolved by arbitration</strong> administered by the <strong>Arbitration Foundation of Southern Africa (AFSA)</strong> in Johannesburg, in accordance with the AFSA rules.</p>
                          <p>13.3.2 The arbitration will be conducted by a single arbitrator appointed by AFSA.</p>
                          <p>13.3.3 The arbitration will be conducted in English.</p>
                          <p>13.3.4 The arbitrator's decision will be final and binding.</p>

                          <h3>13.4 No Class or Consolidated Actions</h3>
                          <div style={{ backgroundColor: "#fff3cd", border: "1px solid #ffc107", padding: "15px", margin: "10px 0", borderRadius: "4px" }}>
                            <p>13.4.1 <strong>To the extent permitted by law</strong>, any dispute, claim, or proceeding against QikTruck must be brought by the Driver <strong>in an individual capacity only</strong> and not as part of any:</p>
                            <ul>
                              <li>(a) Class action;</li>
                              <li>(b) Collective proceeding;</li>
                              <li>(c) Representative action;</li>
                              <li>(d) Consolidated action with claims of other Drivers or persons.</li>
                            </ul>
                            <p>13.4.2 The Driver waives any right to participate in class or collective proceedings against QikTruck, to the extent such waiver is permitted by law.</p>
                          </div>

                          <h3>13.5 CPA Carve-Out</h3>
                          <p>13.5.1 Nothing in this Section 13 prevents either party from referring a complaint or dispute to any applicable regulatory body, tribunal, ombud, or court where such referral is permitted under the CPA or other mandatory consumer protection legislation.</p>
                          <p>13.5.2 The arbitration provisions in this Section apply to commercial disputes between QikTruck and the Driver in the Driver's capacity as an independent contractor and service provider.</p>

                          <hr />

                          {/* SECTION 14: TERMINATION */}
                          <h2>14. TERMINATION</h2>

                          <h3>14.1 Termination by Driver</h3>
                          <p>14.1.1 The Driver may terminate this Agreement at any time by providing 7 days' written notice to QikTruck.</p>

                          <h3>14.2 Termination by QikTruck</h3>
                          <p>14.2.1 QikTruck may terminate this Agreement:</p>
                          <ul>
                            <li>(a) At any time by providing 14 days' written notice to the Driver;</li>
                            <li>(b) Immediately upon material breach by the Driver;</li>
                            <li>(c) Immediately if the Driver's conduct poses a safety risk;</li>
                            <li>(d) Immediately upon fraud, dishonesty, or criminal conduct;</li>
                            <li>(e) Immediately upon loss, suspension, or cancellation of the Driver's licence or insurance.</li>
                          </ul>

                          <h3>14.3 Effect of Termination</h3>
                          <p>14.3.1 Upon termination:</p>
                          <ul>
                            <li>(a) The Driver's access to the Platform will be revoked;</li>
                            <li>(b) The Driver must cease all use of QikTruck branding within 24 hours;</li>
                            <li>(c) Any pending Bookings must be completed or cancelled in coordination with QikTruck;</li>
                            <li>(d) Sections of this Agreement that by their nature should survive (including indemnities, dispute resolution, and confidentiality) will survive termination.</li>
                          </ul>

                          <hr />

                          {/* SECTION 15: POST-TERMINATION PROVISIONS */}
                          <h2>15. POST-TERMINATION PROVISIONS</h2>

                          <h3>15.1 Post-Termination Chargeback Window</h3>
                          <p>15.1.1 QikTruck may deduct or recover from the Driver amounts relating to <strong>chargebacks, refunds, or claims</strong> received for a period of <strong>180 days</strong> after termination, relating to Bookings performed while this Agreement was in effect.</p>
                          <p>15.1.2 The Driver remains liable for such amounts even after termination.</p>

                          <h3>15.2 Withholding Pending Claims</h3>
                          <p>15.2.1 QikTruck may <strong>withhold final disbursement</strong> of Driver Earnings for a period of up to <strong>60 days</strong> after termination to allow for:</p>
                          <ul>
                            <li>(a) Chargebacks to be processed;</li>
                            <li>(b) Customer complaints or claims to be received and assessed;</li>
                            <li>(c) Resolution of any pending disputes or investigations.</li>
                          </ul>
                          <p>15.2.2 After the withholding period, QikTruck will disburse remaining Driver Earnings less any amounts properly deducted.</p>

                          <h3>15.3 Ongoing Insurance Claims</h3>
                          <p>15.3.1 The Driver's obligations to cooperate with claims and investigations (per Section 8) continue after termination for any incidents that occurred while this Agreement was in effect.</p>
                          <p>15.3.2 The Driver must cooperate with subrogation claims and insurer inquiries relating to pre-termination incidents.</p>

                          <hr />

                          {/* SECTION 16: GENERAL PROVISIONS */}
                          <h2>16. GENERAL PROVISIONS</h2>

                          <h3>16.1 Entire Agreement</h3>
                          <p>16.1.1 This Agreement, together with the Platform Terms and Conditions, constitutes the entire agreement between the parties regarding its subject matter.</p>

                          <h3>16.2 Amendments</h3>
                          <p>16.2.1 QikTruck may amend this Agreement from time to time by providing notice through the Platform or by email. Continued use of the Platform after the effective date constitutes acceptance of amendments.</p>

                          <h3>16.3 Severability</h3>
                          <p>16.3.1 If any provision is found to be invalid or unenforceable, the remaining provisions continue in full force.</p>

                          <h3>16.4 No Waiver</h3>
                          <p>16.4.1 Failure to enforce any right or provision does not constitute a waiver of that right or provision.</p>

                          <h3>16.5 Assignment</h3>
                          <p>16.5.1 The Driver may not assign or transfer this Agreement without QikTruck's prior written consent.</p>
                          <p>16.5.2 QikTruck may assign this Agreement to any successor or affiliate.</p>

                          <h3>16.6 Governing Law</h3>
                          <p>16.6.1 This Agreement is governed by the laws of the <strong>Republic of South Africa</strong>.</p>

                          <h3>16.7 Notices</h3>
                          <p>16.7.1 Notices under this Agreement may be given by email to the addresses registered on the Platform or as otherwise specified.</p>

                          <hr />

                          {/* SECTION 17: DRIVER ACKNOWLEDGEMENTS AND WARRANTIES */}
                          <h2>17. DRIVER ACKNOWLEDGEMENTS AND WARRANTIES</h2>
                          <p>By accepting this Agreement, the Driver acknowledges, agrees, and warrants that:</p>
                          <ul>
                            <li>☐ The Driver has read and understood this Agreement in full.</li>
                            <li>☐ The Driver is an independent contractor and not an employee of QikTruck.</li>
                            <li>☐ The contract of carriage is between the Customer and the Driver; QikTruck is not a party to it.</li>
                            <li>☐ QikTruck does not provide Transport Services and is not a carrier.</li>
                            <li>☐ QikTruck does not take custody or control of goods and is not a bailee.</li>
                            <li>☐ The Driver is responsible for CPA performance claims and Customer complaints relating to Transport Services.</li>
                            <li>☐ The Driver consents to chargebacks, refunds, and offsets being deducted from Driver Earnings.</li>
                            <li>☐ The Driver will maintain all required insurance and disclose any lapses or material changes.</li>
                            <li>☐ The Driver will cooperate with claims, investigations, and information requests.</li>
                            <li>☐ The Driver agrees to AFSA arbitration and waives class action participation rights to the extent permitted by law.</li>
                          </ul>

                          <hr />

                          {/* SCHEDULE A: PROHIBITED GOODS */}
                          <h2>SCHEDULE A: PROHIBITED GOODS</h2>
                          <p>The following goods are Prohibited Goods and may not be transported through the Platform:</p>
                          <ol>
                            <li>Illegal drugs, narcotics, or controlled substances</li>
                            <li>Weapons, firearms, ammunition, explosives, or fireworks</li>
                            <li>Hazardous chemicals, toxic substances, radioactive materials</li>
                            <li>Fuel, petroleum products, or flammable liquids (unless expressly pre-approved)</li>
                            <li>Stolen goods or goods of unlawful origin</li>
                            <li>Human remains or body parts</li>
                            <li>Live animals (unless expressly permitted for the Booking type)</li>
                            <li>Perishable items requiring cold chain (unless booked as a fridge service)</li>
                            <li>Currency, bearer instruments, or negotiable documents</li>
                            <li>Goods requiring import/export licences or permits the Customer does not hold</li>
                            <li>Counterfeit goods or goods infringing intellectual property rights</li>
                            <li>Any item unlawful to transport under South African law</li>
                          </ol>

                          <hr />

                          {/* SIGNATURE SECTION */}
                          <h2>ACCEPTANCE</h2>
                          <p>This Agreement may be accepted electronically through the Platform or by signature below.</p>
                          
                          <div style={{ marginTop: "40px" }}>
                            <p><strong>Driver Signature:</strong> _________________________</p>
                            <p><strong>Driver Full Name:</strong> _________________________</p>
                            <p><strong>ID Number:</strong> _________________________</p>
                            <p><strong>Date:</strong> _________________________</p>
                            <p><strong>Driver Email:</strong> _________________________</p>
                            <p><strong>Driver Phone:</strong> _________________________</p>
                          </div>

                          <hr />

                          <div style={{ marginTop: "30px" }}>
                            <p><strong>For QikTruck (Pty) Ltd</strong></p>
                            <p><strong>Authorised Signatory:</strong> _________________________</p>
                            <p><strong>Name:</strong> _________________________</p>
                            <p><strong>Title:</strong> _________________________</p>
                            <p><strong>Date:</strong> _________________________</p>
                          </div>

                          <hr />

                          <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "20px" }}>
                            This Agreement is effective from the date of acceptance and continues until terminated in accordance with its terms.
                          </p>

                          <hr />

                          <h3>Contact Us</h3>
                          <p>If you have questions about this Agreement, contact us:</p>
                          <ContactUs />

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Second Download Button at bottom */}
                <div className="mt-4 text-center">
                  <Button
                    color="primary"
                    size="lg"
                    onClick={this.downloadPDF}
                    className="mb-3"
                  >
                    <i className="mdi mdi-download mr-2"></i>
                    Download Agreement as PDF
                  </Button>
                </div>

              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
